export default function debounce(func, t) {
    return function (args) {
        const previousCall = this.lastCall;
        this.lastCall = Date.now();

        if (previousCall && this.lastCall - previousCall <= t) {
            clearTimeout(this.lastCallTimer);
        }

        this.lastCallTimer = setTimeout(() => func(args), t);
    };
}
